module.exports = __webpack_public_path__ + "203e9f932cc97836ac2ff4c6c982676c.png";